<script setup lang="ts">
import { useModalStore } from '../../ui/modal/modal-store';
const modal = useModalStore()
</script>

<template>
    <div v-for="(item, index) in modal.stack" :key="index">
        <div class="modal fade in" :style="{ zIndex: 1050 + index * 10 }" tabindex="-1">
            <div class="modal-dialog" :class="item.size ? `modal-${item.size}` : ''">
                <div class="modal-content">
                    <component :is="item.component" v-bind="item.props" />
                </div>
            </div>
        </div>
        <div class="modal-backdrop fade in" :style="{ zIndex: 1040 + (index && 1 || 0) + index * 10 }"></div>
    </div>
</template>
